import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";

function Layout() {
  return (
    <div className='flex min-h-screen font-sans'>
      <Sidebar />
      <div className='flex-1 flex flex-col min-w-0 bg-surface-page'>
        <Header />
        <div className='flex-1 overflow-y-auto'>
          <div className='mx-auto px-4 md:px-6 py-4 max-w-[1800px] w-full'>
            <main className='w-full'>
              <Outlet />
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Layout;
